import { CourseType } from "@/models/courses.model";
import { Roles, User } from "@/models/user.model";
import { useCourseStudentStore } from "@/store/course-student";
import { removeAllStorage } from "@/utils/save-storage.util";
import { getUserFromStorage } from "@/utils/user-store.util";

export function guardAuth(to: any, from: any, next: any): void {
  const hasUser = getUserFromStorage();
  const isMeta = "auth" in to.meta;
  const metaAuth = to.meta.auth;

  if (isMeta && metaAuth && !hasUser) {
    next("/sign-in");
    removeAllStorage();
  } else if (isMeta && !metaAuth && hasUser) {
    roleType(hasUser, next);
  } else {
    if (to.meta.pageCourseTraditional === null && hasUser.role === "STUDENT") {
      to.meta.pageCourseTraditional = Boolean(
        useCourseStudentStore.getCourseType !== CourseType.ADAPTATIVE
      );
    }
    next();
  }
}

function roleType(user: User, next: any): void {
  const roleRedirectMap: Record<string, string> = {
    [Roles.ADMINISTRATOR]: "/dashboard-admin",
    [Roles.STUDENT]: "/dashboard-student",
    [Roles.TEACHER]: "/dashboard-teacher",
  };
  const redirectPath = roleRedirectMap[user?.role] || "/organizations";
  next(redirectPath);
}
